import { render } from "./wage-setting.vue?vue&type=template&id=59a9d5be&scoped=true"
import script from "./wage-setting.vue?vue&type=script&lang=js"
export * from "./wage-setting.vue?vue&type=script&lang=js"

import "./wage-setting.vue?vue&type=style&index=0&id=59a9d5be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a9d5be"],['__file',"src/components/applications/wagesetting/wage-setting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59a9d5be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59a9d5be', __exports__)) {
    api.reload('59a9d5be', __exports__)
  }
  
  module.hot.accept("./wage-setting.vue?vue&type=template&id=59a9d5be&scoped=true", () => {
    api.rerender('59a9d5be', render)
  })

}


export default __exports__